import React from 'react';
import { connect } from 'react-redux';
import PerfectScrollbar from "perfect-scrollbar";

import AdminNavbar from "./components/Navbars/AdminNavbar.jsx";
import Footer from "./components/Footer/Footer.jsx";
import Sidebar from "./components/Sidebar/Sidebar.jsx";

import routes from "./routes/routes";
import logo from "./assets/img/react-logo.png";

class Dashboard extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			qClientColor: "#AAD3FF",
			backgroundColor: "#051613",
			sidebarOpened:
				document.documentElement.className.indexOf("nav-open") !== -1
		};
	}

	componentDidMount() {
		// if (navigator.platform.indexOf("Win") > -1) {
		// 	document.documentElement.className += " perfect-scrollbar-on";
		// 	document.documentElement.classList.remove("perfect-scrollbar-off");
		// 	ps = new PerfectScrollbar(this.refs.mainPanel, { suppressScrollX: true });
		// 	let tables = document.querySelectorAll(".table-responsive");
		// 	for (let i = 0; i < tables.length; i++) {
		// 		ps = new PerfectScrollbar(tables[i]);
		// 	}
		// }
	}
	// componentWillUnmount() {
	// 	if (navigator.platform.indexOf("Win") > -1) {
	// 		ps.destroy();
	// 		document.documentElement.className += " perfect-scrollbar-off";
	// 		document.documentElement.classList.remove("perfect-scrollbar-on");
	// 	}
	// }
	// componentDidUpdate(e) {
	// 	if (e.history.action === "PUSH") {
	// 		if (navigator.platform.indexOf("Win") > -1) {
	// 			let tables = document.querySelectorAll(".table-responsive");
	// 			for (let i = 0; i < tables.length; i++) {
	// 				ps = new PerfectScrollbar(tables[i]);
	// 			}
	// 		}
	// 		document.documentElement.scrollTop = 0;
	// 		document.scrollingElement.scrollTop = 0;
	// 		this.refs.mainPanel.scrollTop = 0;
	// 	}
	// }
	toggleSidebar = () => {
		document.documentElement.classList.toggle("nav-open");
		this.setState({ sidebarOpened: !this.state.sidebarOpened });
	};
	getBrandText = path => {
		for (let i = 0; i < routes.length; i++) {
			if (this.props.location.pathname === routes[i].path) {
				return routes[i].name;
			}
		}
	};

	render() {
		return (
			<div className="content">
				<div className="wrapper">
					<Sidebar
						{...this.props}
						routes={routes}
						qClientColor={this.state.qClientColor}
						logo={{
							outterLink: "",
							text: "QClient",
							imgSrc: logo
						}}
						toggleSidebar={this.toggleSidebar}
					/>
					<div
						className="main-panel"
						ref="mainPanel"
						data={this.state.qClientColor}
					>
						<AdminNavbar
							{...this.props}
							// brandText={this.getBrandText(this.props.location.pathname)}
							backgroundColor={this.state.backgroundColor}
							qClientColor={this.state.qClientColor}
							toggleSidebar={this.toggleSidebar}
							sidebarOpened={this.state.sidebarOpened}
							user={this.props.user}
						/>
						{this.props.children}
						{// we don't want the Footer to be rendered on map page
							this.props.location.pathname.indexOf("maps") !== -1 ? null : (
								<Footer fluid />
							)}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(Dashboard);
